import * as types from '../types/brands'
import createReducer from '../createReducer'

const initBrandsState = {}

export default createReducer(initBrandsState, {
  [types.UPDATE_EXISTING_BRAND](state, action) {
    const newBrands = state
    newBrands[action.brand._id] = action.brand
    return Object.assign({}, state, newBrands)
  },
  [types.SET_ALL_BRANDS](state, action) {
    return Object.assign({}, action.brands)
  },
  [types.ADD_NEW_BRAND](state, action) {
    return Object.assign({}, state, { [action.brand._id]: action.brand })
  },
  [types.DELETE_BRAND](state, action) {
    const newState = state
    delete newState[action.brand._id]
    return newState
  },
})
